<template>
  <div class="sticky-atc fixed w-full bottom-0 flex p-5 bg-white cursor-pointer z-50" :class="[...classes]">
    <OButton
      v-bind="buttonProps"
      :attribute="{ name: 'data-qa', value: 'signup-mobile' }"
      @click="$emit('click')"
    >
      {{ text }}
    </OButton>
  </div>
</template>

<script>
const OButton = () => import('@/components/OButton')

export default {
  name: 'StickyATC',
  components: {
    OButton
  },
  props: {
    text: {
      type: String,
      required: true
    },
    classes: {
      type: Array,
      default: () => ([])
    },
    buttonProps: {
      type: Object,
      default: () => ({ variant: 'secondary' })
    }
  }
}
</script>

<style lang="postcss" scoped>
.obutton {
  border-radius: 10rem;
  @apply flex-1;
}
</style>
